// Strings reused verbatim across many admin screens (generic buttons + the
// handful of server-side action errors that repeat almost word-for-word in
// every route's `action()` — "Unknown intent", "Shop not initialized.", etc).
// Screen-specific copy lives in its own namespace file.
export const common = {
  actions: {
    save: "Save",
    saving: "Saving…",
    cancel: "Cancel",
    create: "Create",
    creating: "Creating…",
    send: "Send",
    sending: "Sending…",
    upgrade: "Upgrade",
    back: "Back",
    open: "Open",
    notNow: "Not now",
    close: "Close",
    manage: "Manage",
  },
  errors: {
    shopNotInitialized: "Shop not initialized.",
    unknownIntent: "Unknown intent",
    unknownAction: "Unknown action.",
    tryAgain: "Please try again.",
    tryAgainOrContactSupport: "Please try again or contact support if it keeps happening.",
    notFound: "Not found.",
  },
  misc: {
    notAvailable: "n/a",
    none: "None",
  },
  // Shared enum-style display labels — badges that appear on more than one
  // screen (dashboard, quotes list/detail, AI assistant activity feed).
  quoteStatus: {
    DRAFT: "Draft",
    SENT: "Sent",
    VIEWED: "Viewed",
    ACCEPTED: "Accepted",
    DECLINED: "Declined",
    EXPIRED: "Expired",
    // Matches the real QuoteStatus enum spelling (packages/quote-engine) —
    // one "L", US spelling. Do not rename to "CANCELLED"; nothing in the
    // codebase produces that value and the dynamic `t(`common.quoteStatus.
    // ${status}`)` lookup would silently miss it.
    CANCELED: "Cancelled",
  },
  dataSufficiency: {
    HIGH: "High",
    MEDIUM: "Medium",
    LOW: "Low",
  },
};
